/* eslint-disable react/forbid-elements */
import { H2, Paragraph, Section, YStack } from '@bounty/creators-design-system'
import { format } from 'date-fns'

export const ProblemStatement = () => {
  return (
    <Section py="$14" containerSize="md" $gtMd={{ flexDirection: 'row' }}>
      <YStack mb="$4" flex={1} $gtMd={{ width: '50%' }}>
        <YStack className="responsive-iframe">
          <iframe
            title="intro"
            src="https://www.loom.com/embed/83c6f1131524434d8033789872c43dd4?hide_owner=true&hide_share=true&hide_title=true&hideEmbedTopBar=true"
            frameBorder="0"
            allowFullScreen
          ></iframe>
        </YStack>
      </YStack>
      <YStack flex={1} $gtMd={{ width: '50%', pl: '$14' }}>
        <H2 size="$xl" mb="$2" $gtMd={{ size: '$3xl', mb: '$4' }}>
          It's {format(new Date(), 'yyyy')}, shouldn't working with creators be
          easy by now?
        </H2>
        <Paragraph $gtMd={{ size: '$lg' }}>
          You could keep searching for creators, managing outreach, struggling
          with inauthentic UGC, reviewing and approving content, haggling over
          usage rights, draining your time and budget... or you could use
          Bounty.
        </Paragraph>
      </YStack>
    </Section>
  )
}
